import React from 'react'
import { Row, Col, Container } from 'react-bootstrap'
import { StaticQuery, graphql } from 'gatsby'
import { GatsbyImage, getImage } from "gatsby-plugin-image";
import styled from 'styled-components'
import AnimatedHeading from 'components/animated-heading-host-services'

class ServicesOne extends React.Component {


    shouldComponentUpdate() {
        return false
    }
      

    render() {
        const Section = styled.section`
            position: relative;
            overflow: hidden;
            background-color: #000;            
            background-size: cover;
            padding: 100px 0 50px 0;
            .heading {
                width: 100%;
            }
            @media (max-width: 767px) {
                padding: 10px 0 20px 0;           
            }
            @media (min-width:768px) and (max-width:1500px) {
                padding: 50px 0 50px 0;              
            }
          }
        `

        const ServiceContainer = styled.div`
            background-color: rgba(0,0,0,.9);
            padding: 60px 0;
        `


        const ServiceElement = styled.div`
            margin-bottom: 20px;
            text-align: center;
            padding: 40px;
            border-radius: 20px;
            transition: .2s;
            &:hover {
                background-color: #000;
                box-shadow: 0 28px 60px rgb(193, 235, 24, .4);
                transform: translateY(-10px);
            }
        `
         const ServiceHeading = styled.h3`
            font-size: 30px;
            font-weight: 500;
            font-family: Teko;
            color: #fff;
        `
        const ServiceSeparator = styled.div`
            height: 5px;
            width: 50px;
            background-color: #c1eb18;
            margin: auto auto 10px auto;        
         `
        const ServiceIcon = styled.div`
      margin-bottom: 20px;
      img {
        max-height: 70px;
        max-width: 70px;
        width: 100%;
        height: auto;
      }
    `

        const ServiceText = styled.p`
            font-size: 16px;
            font-weight: 300;
            color: #c5c5c5;
            padding-right: 25px;
            text-align: left;           
        `

        const Text = styled.p`
            font-size: 18px;
            font-weight: 300;
            color: #ffffff;
            padding-bottom: 30px;
            text-align: center;          
        `

        const Color = styled.span`            
            font-weight: bold;
            color: #c1eb18;            
        `

        const Color1 = styled.span`            
            color: #c1eb18;            
        `

        const Color2 = styled.span`            
            color: #04e5e5;            
        `

        return(
          <Section>
            <ServiceContainer>
              <Container>
                <AnimatedHeading text="Características" />
                <AnimatedHeading text="del VPS KVM" />
                <Text>
                  Sumérgete en el fascinante mundo de los Servidores Virtuales Privados (VPS) con tecnología Kernel-based Virtual Machine (KVM).
                </Text>
                <Text>
                  Al explorar la tecnología KVM en VPS, se obtiene un control total sobre el entorno virtual. Además, el aislamiento robusto garantiza
                  la seguridad de las operaciones, brindando a los usuarios un nivel de control y seguridad que va más allá de las soluciones convencionales.
                </Text>

                <Row>
                  <Col md={4}>
                    
                      <ServiceElement>
                        <ServiceIcon>
                          <GatsbyImage image={this.props.image1} alt="Servidores Linux" />
                        </ServiceIcon>
                        <ServiceHeading>
                          Elija su SO Linux favorita
                        </ServiceHeading>
                        <ServiceSeparator />
                        <ServiceText>
                          Optar por <Color2>CentOS 7, Debian 9, Debian 10, Ubuntu 18.04 o Ubuntu 20.04.</Color2>
                        </ServiceText>
                        <ServiceText>
                          La versión <Color>HDD solo permite Centos 7</Color>.
                        </ServiceText>
                      </ServiceElement>
                    
                  </Col>
                  <Col md={4}>
                    
                      <ServiceElement>
                        <ServiceIcon>
                          <GatsbyImage image={this.props.image2} alt="Red privada" />
                        </ServiceIcon>
                        <ServiceHeading>
                          Red privada
                        </ServiceHeading>
                        <ServiceSeparator />
                        <ServiceText>
                          Aislamiento de recursos garantizado en servidores autónomos que se pueden configurar y utilizar de forma autónoma.
                        </ServiceText>
                      </ServiceElement>
                    
                  </Col>
                  <Col md={4}>
                    
                      <ServiceElement>
                        <ServiceIcon>
                          <GatsbyImage image={this.props.image3} alt="Soporte rDNS" />
                        </ServiceIcon>
                        <ServiceHeading>
                          Soporte rDNS
                        </ServiceHeading>
                        <ServiceSeparator />
                        <ServiceText>
                          Nuestros servidores privados virtuales cuentan con soporte rDNS para una experiencia de envío de correo ordenada y libre de spam.

                        </ServiceText>
                      </ServiceElement>
                    
                  </Col>
                  <Col md={4}>
                    
                      <ServiceElement>
                        <ServiceIcon>
                          <GatsbyImage image={this.props.image4} alt="VPS con recursos garantizados" />
                        </ServiceIcon>
                        <ServiceHeading>
                          Recursos garantizados
                        </ServiceHeading>
                        <ServiceSeparator />
                        <ServiceText>
                          Garantizamos que tus recursos, desde potencia de procesamiento hasta almacenamiento, sean dedicados y exclusivos.
                        </ServiceText>
                      </ServiceElement>
                    
                  </Col>
                  <Col md={4}>
                    
                      <ServiceElement>
                        <ServiceIcon>
                          <GatsbyImage image={this.props.image5} alt="VPS instantáneo" />
                        </ServiceIcon>
                        <ServiceHeading>
                          Aprovisionamiento rápido
                        </ServiceHeading>
                        <ServiceSeparator />
                        <ServiceText>
                          Configuración y <Color1>entrega de servidores virtuales ultrarrápidas.</Color1><br></br><br></br>
                        </ServiceText>
                      </ServiceElement>
                    
                  </Col>
                  <Col md={4}>
                    
                      <ServiceElement>
                        <ServiceIcon>
                          <GatsbyImage image={this.props.image6} alt="Protección DDoS" />
                        </ServiceIcon>
                        <ServiceHeading>
                          Protección DDoS de Neustar
                        </ServiceHeading>
                        <ServiceSeparator />
                        <ServiceText>
                          Monitorización activa de red y bloqueo de IP por parte de Neustar.<br></br><br></br>
                        </ServiceText>
                      </ServiceElement>
                    
                  </Col>
                </Row>
              </Container>
            </ServiceContainer>
          </Section>
        )
    }

}

const Iconos = (props) => (
  <StaticQuery
      query={graphql`
      {          
        image1: file(relativePath: { eq: "icons/linuxserver.png" }) {
          childImageSharp {
            gatsbyImageData(
              layout: CONSTRAINED
              placeholder: DOMINANT_COLOR
              quality: 80
              formats: [AUTO, WEBP, AVIF]
              width: 70
            )
          }
        }
        image2: file(relativePath: { eq: "icons/private.png" }) {
          childImageSharp {
            gatsbyImageData(
              layout: CONSTRAINED
              placeholder: DOMINANT_COLOR
              quality: 80
              formats: [AUTO, WEBP, AVIF]
              width: 70
            )
          }
        }
        image3: file(relativePath: { eq: "icons/inverse.png" }) {
          childImageSharp {
            gatsbyImageData(
              layout: CONSTRAINED
              placeholder: DOMINANT_COLOR
              quality: 80
              formats: [AUTO, WEBP, AVIF]
              width: 70
            )
          }
        }
        image4: file(relativePath: { eq: "icons/cpu.png" }) {
          childImageSharp {
            gatsbyImageData(
              layout: CONSTRAINED
              placeholder: DOMINANT_COLOR
              quality: 80
              formats: [AUTO, WEBP, AVIF]
              width: 70
            )
          }
        }
        image5: file(relativePath: { eq: "icons/alarm.png" }) {
          childImageSharp {
            gatsbyImageData(
              layout: CONSTRAINED
              placeholder: DOMINANT_COLOR
              quality: 80
              formats: [AUTO, WEBP, AVIF]
              width: 70
            )
          }
        }
        image6: file(relativePath: { eq: "icons/ddos.png" }) {
          childImageSharp {
            gatsbyImageData(
              layout: CONSTRAINED
              placeholder: DOMINANT_COLOR
              quality: 80
              formats: [AUTO, WEBP, AVIF]
              width: 70
            )
          }
        }        
      }
    `}
      render={(data) => {            
          const image1 = getImage(data.image1.childImageSharp.gatsbyImageData);
          const image2 = getImage(data.image2.childImageSharp.gatsbyImageData);
          const image3 = getImage(data.image3.childImageSharp.gatsbyImageData);
          const image4 = getImage(data.image4.childImageSharp.gatsbyImageData);
          const image5 = getImage(data.image5.childImageSharp.gatsbyImageData);
          const image6 = getImage(data.image6.childImageSharp.gatsbyImageData);          
          return <ServicesOne data={data} image1={image1} image2={image2} image3={image3} image4={image4} image5={image5} image6={image6}{...props} />;
      }}
  />
);

export default Iconos;
